import {DEFAULT_ENTITY_NAMED_LIST} from 'app/app.constants';
import {EntityView} from 'app/blocks/util/entity-view';
import {FilterParams} from 'app/blocks/util/filter-params';
import {ListViewParams} from 'app/blocks/util/list-view-params';
import {toIsoLocalDateTimeString} from 'app/common/utils/date-utils';
import moment from 'moment';
import {PartialEntityStateModel} from 'app/blocks/store/state-model/partial-entity-state-model';

export interface LegTrafficSheetStateModel<T> extends PartialEntityStateModel<T> {
    listView: {
        initialized: boolean;
        entityList: T[];
        totalItems: number;
        viewParams: ListViewParams;
        statusLoading: boolean;
        selectedIds: number[];
    };
    entityView: {
        currentEntity: T;
        statusSaving: boolean;
        statusDeleting: boolean;
        selectedTabIndex: number;
        mainForRun: boolean;
        treeList: boolean;
        key: string;
    };
    currentView: EntityView;
}

export const defaultLegTrafficSheetState = (entityCreator: (entity?) => any, reverse = false, field = 'plannedStartTime') => {
    return {
        listView: {
            initialized: false,
            entityList: [],
            totalItems: 0,
            viewParams: LegtrafficSheetlistViewParams(reverse, field),
            statusLoading: false,
            selectedIds: []
        },
        entityView: {
            currentEntity: entityCreator(),
            statusSaving: false,
            statusDeleting: false,
            selectedTabIndex: 0,
            entityIds: []
        },
        partialEntity: {
            [DEFAULT_ENTITY_NAMED_LIST]: {
                list: [],
                loaded: false
            }
        },
        currentView: EntityView.LIST
    };
};

function LegtrafficSheetlistViewParams(desc = false, field = 'plannedStartTime'): ListViewParams {
    const filters: FilterParams[] = [];
    return {
        pageIndex: 0,
        pageSize: 100,
        sortColumn: field,
        sortDirection: desc ? 'desc' : 'asc',
        filter: '',
        filterParams: filters
    } as ListViewParams;
}
